var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3106 18.7714C9.93984 19.2905 9.22128 19.3429 8.78659 18.8828L8.69655 18.7876C8.34648 18.417 8.30079 17.8328 8.58857 17.4064L13.0407 11.9631L8.58865 6.58735C8.30088 6.16091 8.34655 5.57675 8.69664 5.20619L8.78667 5.11089C9.22136 4.65077 9.93991 4.70333 10.3107 5.22237L15.3949 11.3165C15.6682 11.699 15.6682 12.2272 15.3949 12.6096L10.3106 18.7714Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/chevron_right_icon.e95d311304d9785d6cf7a898089c197f.svg";
export { ForwardRef as ReactComponent };